import React, { useEffect } from 'react';

import { useFilters } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportDetailsProps, ReportTab, ReportTypeKeys } from '../../report.types';
import { useGetReportEmployerId } from '../hooks';
import ReportDetailsBase from '../ReportDetailsBase';

import PrefundInvoiceReportSummary from './PrefundInvoiceReportSummary';
import ContributionInvoiceReportTable from './PrefundInvoiceReportTable';
import { PrefundInvoiceReportTableParams, PrefundInvoiceSummaryReportParams } from './PrefundReport.types';

type FiltersValues = PrefundInvoiceReportTableParams &
  PrefundInvoiceSummaryReportParams & {
    tab: ReportTab;
  };
interface Props extends ReportDetailsProps<FiltersValues> {}
const PrefundInvoiceReportDetails: React.FC<Props> = ({
  defaultEmployerId,
  defaultTab,
  isPreviewMode,
  onChangeFilters,
  defaultFilterValues,
}) => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      tab: defaultTab || ReportTab.Summary,
      employerId: defaultEmployerId || employerId || '',
      searchString: '',
      isSSNShowed: false,
      startDate: null,
      endDate: null,
      invoiceID: '',
      ...defaultFilterValues,
    },
    {
      disabled: isPreviewMode,
      autoClear: true,
    }
  );
  useEffect(() => {
    if (employerId && !filtersValues.employerId) {
      setFilterValue.employerId(employerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerId]);
  useEffect(() => {
    setFilterValue.invoiceID('');
    setFilterValue.startDate(null);
    setFilterValue.endDate(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersValues.employerId]);
  useEffect(() => {
    if (defaultTab) {
      setFilterValue.tab(defaultTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);
  useEffect(() => {
    if (isPreviewMode && onChangeFilters) {
      onChangeFilters(filtersValues);
    }
  }, [filtersValues, isPreviewMode, onChangeFilters]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.PrefundInvoiceCard);
  return (
    <ReportDetailsBase
      isPreviewMode={isPreviewMode}
      isFavorite={isFavorite}
      onToggleFavorite={handleToggleReportKey}
      tab={filtersValues.tab}
      onSetTab={setFilterValue.tab}
      title="Prefund Invoice"
    >
      {filtersValues.tab === ReportTab.Report ? (
        <ContributionInvoiceReportTable
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          key={filtersValues.tab}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      ) : (
        <PrefundInvoiceReportSummary
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      )}
    </ReportDetailsBase>
  );
};

export default PrefundInvoiceReportDetails;
